/* eslint-disable arrow-body-style */

import React from "react";

// Custom
import modelIzlet from "@/models/izlet";
import modelIzletVodicSudionik from "@/models/izlet_vodic_sudionik";
import DataCentricPage from "@/views/DataCentric/DataCentricPage";
import HPSIzletForm from "./Forms/HPSIzletForm";
import { Permissions } from "@/lib/permissions";

const UdrugaIzletiPage = () => {
  return (
    <DataCentricPage
      needPermission={[Permissions.HPSPlanUdrugaView, Permissions.Administration]}

      primaryModel={modelIzlet}
      primaryTitleToken="titles.izleti_udruga"
      primaryView="udruga"
      primaryAllowAdd={false}
      primaryAllowView
      primaryDialogForm="udruga"
      primaryDialogComponent={HPSIzletForm}
      primaryAllowEdit={false}
      primaryAllowGeneratePDF
      primaryAllowShareIzlet={false}
      primaryAllowGenerateVodickiObrazac={false}
      primaryOverrideAPIUrl="hps/izleti?type=udruga"
      primaryExportLabel="buttons.export_xlsx_izleti"
      primaryAllowApprove
      primaryAllowToggleJavno
      primaryAllowToggleOdrzan
      primaryIzletiAdminFlagChangeType="pu"

      secondaryModel={modelIzletVodicSudionik}
      secondaryTitleToken="titles.vodici_sudionici"
      secondaryView="udruga"
      secondaryAllowView={false}
      
      baseRecordPath={modelIzlet.apiPath}
      childRecordRelativePath="vodici-i-sudionici"
      geomRelativePath="geom"
      miniMapBaseRecordQueryParams="?type=udruga"
      
      mapId={10}
      mapModel={modelIzlet}
    />
  )
};

export default UdrugaIzletiPage;
